import { Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-information-field',
  templateUrl: './information-field.component.html',
  styleUrl: './information-field.component.scss',
  imports: [TranslatePipe],
})
export class InformationFieldComponent {
  readonly labelKey = input('')
}
